"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIssuesTypes = void 0;
var _hooks = require("../../state/redux/hooks");
var _issueTypes = require("../../state/redux/ducks/issueTypes");
const useIssuesTypes = () => {
  const groupedTypes = (0, _hooks.useSelector)(_issueTypes.getActiveGroupedTypes);
  return groupedTypes;
};
exports.useIssuesTypes = useIssuesTypes;
//# sourceMappingURL=useIssuesTypes.js.map